// extracted by mini-css-extract-plugin
module.exports = {"slider-container":"NotificationBar_slider-container__I7ZWR","text-heading":"NotificationBar_text-heading__dD1tv","text-content":"NotificationBar_text-content__y4rCm"};